import { CollapseProps } from 'antd';
import { FormikProps } from 'formik';

import { MFilter } from '@Components/Base';
import { useAppSelector } from '@Hooks/index';
import { Input, Select } from '@Components/Filters';
import { getCompanyOptionsNum } from '@Store/selectors/dictionarySelector';

import { FilterForm } from './types';

interface FiltersProps {
  formik: FormikProps<FilterForm>;
  showError?: boolean;
}

const Filters: React.FC<FiltersProps> = ({ formik, showError = false }) => {
  const companyOptions = useAppSelector(getCompanyOptionsNum);

  const items: CollapseProps['items'] = [
    {
      id: 'EMPLOYEE NUMBER',
      label: 'Employee Number',
      children: <Input<FilterForm> formik={formik} formikKey="empNumber" />,
    },
    {
      id: 'COMPANY',
      label: 'Company',
      children: (
        <Select<FilterForm>
          formik={formik}
          formikKey="company"
          options={companyOptions}
        />
      ),
    },
  ];

  return (
    <MFilter<FilterForm> showError={showError} formik={formik} items={items} />
  );
};

export default Filters;
